const { sanitiseBatchNo } = require('../../../batch/tools')
const { SHIPSY_SOURCE, STOCK_TRANSACTION_TYPES } = require('../../constants')

// RTV payload:
//   { warehouse, supplier_id, request_id, rtv_date, items: [
//       { sku_code, batch_no, rtv_quantity, zone, reason, grn_json_data: { created_by } }
//     ] }
// warehouse is a location code; supplier_id is a UUID in our location table
// (same lookup pattern the RTV domain handler uses).
async function extract (payload, { mainApi }) {
  const items = payload && payload.items
  if (!Array.isArray(items) || items.length === 0) return []
  if (!payload.warehouse || !payload.supplier_id) return []

  const warehouse = await mainApi.location.pgAdapter.getOneByCode(payload.warehouse)
  const supplier = await mainApi.location.pgAdapter.getOne(payload.supplier_id, { whereCondition: 'uuid' })

  const requestId = String(payload.request_id)
  const rows = []

  for (const item of items) {
    const quantity = Number(item.rtv_quantity)
    if (quantity <= 0) continue

    const createdBy = item.grn_json_data && item.grn_json_data.created_by

    rows.push({
      source: SHIPSY_SOURCE,
      type: STOCK_TRANSACTION_TYPES.RTV,
      request_id: requestId,
      origin: warehouse.fsid,
      origin_zone: item.zone || null,
      destination: supplier.fsid,
      destination_zone: null,
      sku: String(item.sku_code),
      batch: sanitiseBatchNo(item.batch_no || 'UNKNOWN'),
      quantity,
      reason: item.reason,
      payload: item,
      created_at: payload.rtv_date,
      created_by: createdBy,
      updated_at: payload.rtv_date,
      updated_by: createdBy
    })
  }

  return rows
}

module.exports = extract
